module.exports = __webpack_public_path__ + "img/home_banner_4.efbe3072.png";